import React from 'react';
import { useSelector } from 'react-redux';

import toDollars from 'utils/to-dollars';
import hoursToDuration from 'utils/hours-to-duration';

// Selectors
// @ts-ignore
import { makeSelectGroupedDataValueTotal } from 'services/timesheetTimesheetEntriesForm/selectors';

interface Props {
    dollars?: boolean;
    groupingId?: any;
    hours?: boolean;
    fieldName: string;
}

export default function TimesheetTimesheetEntriesTableGroupingTotal(
    props: Props
): React.ReactElement | null {
    const { dollars, groupingId, hours, fieldName } = props;

    const total: number = useSelector((state: any) =>
        makeSelectGroupedDataValueTotal()(state, { groupingId, fieldName })
    );
    if (!total) return null;

    let displayVal = total.toFixed(2);

    if (dollars) {
        displayVal = toDollars(total);
    }
    if (hours) {
        displayVal = hoursToDuration(total);
    }

    return (
        <React.Fragment>
            {displayVal}
        </React.Fragment>
    );
}
